(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["general-faq-tabs"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("DOMContentLoaded", (event) => {
  const mediaQuery = window.matchMedia('(max-width: 990px)')
  if (mediaQuery.matches) {
      const swiper = new Swiper('.general-faq-tabs__tabs', {
        loop: false,
        slidesPerView: 1.9,
        spaceBetween: 24,
        centeredSlides: false,
        centeredSlidesBounds: false,
      });
  }

  document.querySelectorAll('.general-tab-link').forEach((item, index) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      let activeLink = document.querySelector('.general-tab-link--active');
      if(activeLink) {
        activeLink.classList.remove('general-tab-link--active')
      }
      e.target.classList.add('general-tab-link--active');

      document.querySelectorAll('.section-general-faq').forEach((element, elIndex) => {
        element.classList.remove('active');
        if(index === 0) {
          element.classList.add('active');
        } else {
          let indexTo = index - 1;
          if(indexTo === elIndex) {
            element.classList.add('active');
          }
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-popular-articles"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("DOMContentLoaded", (event) => {
  const mediaQuery = window.matchMedia('(max-width: 767px)')
  if (mediaQuery.matches) {
      const swiper = new Swiper('.other-posts .swiper', {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: false,
        centeredSlidesBounds: false,
      });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["other-posts"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("DOMContentLoaded", (event) => {
  const mediaQuery = window.matchMedia('(max-width: 767px)')
  if (mediaQuery.matches) {
      const swiper = new Swiper('.other-posts .swiper', {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: false,
        centeredSlidesBounds: false,
      });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-slider"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("DOMContentLoaded", (event) => {
  const mediaQuery = window.matchMedia('(max-width: 767px)')
  let swiperPagination = false;
  if (mediaQuery.matches) {
    swiperPagination = new Swiper('.process-slider .process-slider-pagination', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: true,
      centeredSlidesBounds: false,
    });
  }

  const swiper = new Swiper('.process-slider .swiper', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: false,
    centeredSlidesBounds: false,
    pagination: {
      el: '.process-slider-pagination',
      type: 'custom',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChange: function (swiper) {
        let pagination = document.querySelectorAll('.process-slider .swiper-pagination-custom-item');
        if(pagination) {
          pagination.forEach((item) => {
            item.classList.remove('active')
          });
          if(pagination[swiper.activeIndex]) {
            pagination[swiper.activeIndex].classList.add('active')
          }
        }
      },
      slideNextTransitionStart: (swiper) => {
        if(swiperPagination) {
          swiperPagination.slideNext();
        }
      },
      slidePrevTransitionStart: (swiper) => {
        if(swiperPagination) {
          swiperPagination.slidePrev();
        }
      }
    },
   
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-headings"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-tabs-link').forEach(element => {
        element.addEventListener('click', ev => {
          ev.preventDefault();
          var targetElement = document.querySelector(ev.target.getAttribute('href'));
          var targetPosition = targetElement.offsetTop;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-releases-slider"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("DOMContentLoaded", (event) => {
  const swiper = new Swiper('.recent-releases-slider .swiper', {
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 20,
    centeredSlides: false,
    centeredSlidesBounds: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'custom',
      clickable: true,
      renderCustom: function (swiper, current, total) {
        let out = '';
        for(let i=1; i<=total; i++) {
          out += `<div role="button" tabindex="0" class="swiper-pagination-custom-item swiper-pagination-bullet`
            if(i == current) {
              out += ` active`
            }
          out += `">${i}</div>`
        }
        return out;
      }
    },
    breakpoints: {
    // when window width is >= 320px
    750: {
      slidesPerView: 1.6,
      centeredSlidesBounds: true,
    }
  }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("DOMContentLoaded", (event) => {

  const swiper = new Swiper('.reviews-slider .swiper', {
    loop: false,
    slidesPerView: 1.23,
    spaceBetween: 20,
    centeredSlides: false,
    centeredSlidesBounds: false,
    navigation: {
      nextEl: '.reviews-slider-navigation--mobile .swiper-button-next',
      prevEl: '.reviews-slider-navigation--mobile .swiper-button-prev',
    },
    breakpoints: {
    750: {
      navigation: {
        nextEl: '.reviews-slider-navigation--desktop .swiper-button-next',
        prevEl: '.reviews-slider-navigation--desktop .swiper-button-prev',
      },
      slidesPerView: 1.8,
    }
  }
   
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.videos__video video').forEach(vid => {
let playBtn = vid.parentElement.querySelector('.video_play');
if(playBtn) {
vid.addEventListener("pause", (event) => {
playBtn.classList.remove('hidden');
});
vid.addEventListener("play", (event) => {
playBtn.classList.add('hidden')
});
}
});
document.querySelectorAll('.video_play').forEach(item => {
item.addEventListener('click', ev => {
ev.preventDefault();
let vid = ev.target.closest('.videos__video-cover').querySelector('video');
if(vid) {
vid.play();
}
});
});
const viewMoreVidsBtn = document.querySelector('.view-more-videos-btn');
if(viewMoreVidsBtn) {
viewMoreVidsBtn.addEventListener('click', function(e) {
e.preventDefault();
const hiddenGrid = document.querySelectorAll('.videos__video--hidden');
if(hiddenGrid) {
  hiddenGrid.forEach(element => {
    element.classList.toggle('is-visible');
    
  });
e.target.classList.toggle('hidden');
}
})
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.videos__video video').forEach(vid => {
let playBtn = vid.parentElement.querySelector('.video_play');
if(playBtn) {
vid.addEventListener("pause", (event) => {
playBtn.classList.remove('hidden');
});
vid.addEventListener("play", (event) => {
playBtn.classList.add('hidden')
});
}
});
document.querySelectorAll('.video_play').forEach(item => {
item.addEventListener('click', ev => {
ev.preventDefault();
let vid = ev.target.closest('.videos__video-cover').querySelector('video');
if(vid) {
vid.play();
}
});
});
const viewMoreVidsBtn = document.querySelector('.view-more-videos-btn');
if(viewMoreVidsBtn) {
viewMoreVidsBtn.addEventListener('click', function(e) {
e.preventDefault();
const hiddenGrid = document.querySelector('.videos-grid--hidden');
if(hiddenGrid) {
hiddenGrid.classList.toggle('is-visible');
e.target.classList.toggle('hidden');
}
})
}



  } catch(e) { console.error(e); }
})();
})();
